import React from "react";
import { useNavigate } from "react-router-dom";

export default function UnauthorizedPage() {
  const navigate = useNavigate();
  return (
    <div style={{ textAlign: "center", padding: 80 }}>
      <span style={{ fontSize: 48 }}>🔒</span>
      <h2>Access Denied</h2>
      <p>You don't have permission to view this page.</p>
      <button onClick={() => navigate(-1)}>Go Back</button>
    </div>
  );
}
